module.exports = __webpack_public_path__ + "images/mdj/members/resume/quick_resume/btn_radio_sp_off-0298fbcc27bd4fa9854b49a461c2f67d.png";